export default "__VITE_ASSET__TxXltvkd__"